/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Hoechsterberufsabschluss2Inputs */



/**

* @param {_Field_Hoechsterberufsabschluss2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_hoechsterberufsabschluss2 = /** @type {((inputs?: _Field_Hoechsterberufsabschluss2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Hoechsterberufsabschluss2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Höchster Berufsabschluss")
});
export { _field_hoechsterberufsabschluss2 as "_field_hoechsterBerufsAbschluss" }